module.exports = __webpack_public_path__ + "static/media/Wallet.2df1b557.svg";